module.exports = __webpack_public_path__ + "img/alipay_zf.ac9fdd8f.jpg";